<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      data: null,
    };
  },

  props: ["url"],

  computed: {},

  created() {},

  mounted() {
    this.getData();
  },

  watch: {},

  methods: {
    getData() {
      axios
        .get(this.url)
        .then((response) => {
          this.data = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
